<h2 mat-dialog-title>Recreate Service Request</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <h4>Service Request Details</h4>
      </div>
      <div class="col-12">
        <mat-form-field class="w-100">
          <mat-label>Service Request ID</mat-label>
          <input matInput formControlName="serviceRequestId" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Customer ID</mat-label>
          <input matInput formControlName="customerId" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Order Number</mat-label>
          <input matInput formControlName="orderNumber" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>OTP (4 digits)</mat-label>
          <input matInput formControlName="otp" type="text" maxlength="4" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Package Count</mat-label>
          <input matInput formControlName="packageCount" type="number" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Weight (kg)</mat-label>
          <input matInput formControlName="weight" type="number" step="0.1" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Volume (cm³)</mat-label>
          <input matInput formControlName="volume" type="number" step="0.1" />
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field class="w-100">
          <mat-label>Notes (optional)</mat-label>
          <textarea matInput formControlName="notes" rows="2"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <h4>Pickup Address</h4>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Street</mat-label>
          <input matInput formControlName="pickupStreet" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Street Number</mat-label>
          <input matInput formControlName="pickupStreetNumber" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Suburb</mat-label>
          <input matInput formControlName="pickupSuburb" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Province</mat-label>
          <input matInput formControlName="pickupProvince" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Postal Code</mat-label>
          <input matInput formControlName="pickupPostalCode" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Country</mat-label>
          <input matInput formControlName="pickupCountry" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Latitude</mat-label>
          <input
            matInput
            formControlName="pickupLatitude"
            type="number"
            step="0.000001"
          />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Longitude</mat-label>
          <input
            matInput
            formControlName="pickupLongitude"
            type="number"
            step="0.000001"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <h4>Delivery Address</h4>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Street</mat-label>
          <input matInput formControlName="deliveryStreet" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Street Number</mat-label>
          <input matInput formControlName="deliveryStreetNumber" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Suburb</mat-label>
          <input matInput formControlName="deliverySuburb" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Province</mat-label>
          <input matInput formControlName="deliveryProvince" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Postal Code</mat-label>
          <input matInput formControlName="deliveryPostalCode" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Country</mat-label>
          <input matInput formControlName="deliveryCountry" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Latitude</mat-label>
          <input
            matInput
            formControlName="deliveryLatitude"
            type="number"
            step="0.000001"
          />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label>Longitude</mat-label>
          <input
            matInput
            formControlName="deliveryLongitude"
            type="number"
            step="0.000001"
          />
        </mat-form-field>
      </div>
    </div>

    @if (error) {
    <app-alert class="mt-3" type="error" (close)="error=null">
      {{ error }}
    </app-alert>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button [disabled]="loading" mat-button mat-dialog-close>Cancel</button>
  @if (loading) {
  <mat-spinner class="me-2" diameter="30" />
  }
  <button
    [disabled]="loading"
    mat-raised-button
    color="primary"
    (click)="onFormSubmit()"
  >
    Recreate Service Request
  </button>
</mat-dialog-actions>
